import permission from './permission'
import functionIndex from './functionIndex'
import drag from './drag'
import input from './input'
// 自定义指令
const directives = {
  permission,
  drag,
  input
}

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  }
}

export {
  functionIndex
}
